import {
    getFetching as getFetchingImport,
    getOutdated as getOutdatedImport,
    getNews as getNewsImport,
    getLanguage as getLanguageImport,
    getLocalizedNews as getLocalizedNewsImport,
    getLocalizedNewsForLocale as getLocalizedNewsForLocaleImport,
} from './feed/selectors'

const feed = {
    getFetching: state => getFetchingImport(state.feed),
    getOutdated: state => getOutdatedImport(state.feed),
    getNews: state => getNewsImport(state.feed),
    getLanguage: state => getLanguageImport(state.feed),
    getLocalizedNews: state => getLocalizedNewsImport(state.feed),
    getLocalizedNewsForLocale: (state, locale) =>
        getLocalizedNewsForLocaleImport(state.feed, locale),
}

// eslint-disable-next-line
export const selectors = { feed }



// WEBPACK FOOTER //
// ./src/features/News/data/selectors.js